import AppLocale from '../providers/IntlProviderWrapper/AppLocale'
import { getDefaultLocalLanguage } from './utils'

const translateIntlMsgString = (intlMsgString) =>
	AppLocale[getDefaultLocalLanguage()][intlMsgString]

export default translateIntlMsgString
